export function uniqueDocName(base: string, existing: Iterable<string>): string {
    const taken = new Set(existing);
    if (!taken.has(base)) return base;
    for (let i = 2; ; i++) {
        const candidate = `${base} ${i}`;
        if (!taken.has(candidate)) return candidate;
    }
}
